export default "__VITE_ASSET__BZAwZykQ__"